// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import util from '../../../share/util/utils';
import loading from '../../../share/components/vue/ProcessingIcon';
import config from '../../../share/config';

const SELECT_SYSTEMS_LIMIT = {
  // 選択可能システム数
  MIN: 2, // 最小選択数
  MAX: 3, // 最大選択数
};

export default {
  name: "multipleEcuTable",
  data() {
    return {
      processing: false,
      systemListItems: [],
      isLangRu: false,
      selectedSystemIds: [], // 選択されたシステムIDを保持
    };
  },

  watch: {
    language: {
      immediate: true,
      handler(val) {
        this.updateEcuTable();
        // ロシア語の場合、文字サイズを小さくする
        this.isLangRu = val === "ru" ? true : false;
      }
    },
  },

  components: {
    'processing-view': loading,
  },

  // router params 対応
  props: ["functionName"],

  methods: {
    ...mapActions('auth', ['logout']),


    /**
     * クリックしたItemの選択/選択解除処理を行う
     * @param {object} systemId 選択したシステムID
     */
    clickItem(systemId) {
      const index = this.selectedSystemIds.indexOf(systemId);
      if (index === -1) {
        // 未選択のECUが選択された場合、選択数を確認
        if (this.selectedSystemIds.length < SELECT_SYSTEMS_LIMIT.MAX) {
          // 選択数が上限未満の場合は選択可能
          this.selectedSystemIds.push(systemId);
        }
      } else {
        // 選択解除
        this.selectedSystemIds.splice(index, 1);
      }
    },

    /**
     * 決定のクリック処理
     */
    clickDecision() {
      let routeName = "";
      switch (this.functionName) {
        // 機能ごとに遷移先を設定
        case 'data_monitor':
          routeName = "multipleDataMonitor";
          break;
        default:
          break;
      }

      if (routeName !== "") {
        // 画面遷移
        this.$router.push({
          name: routeName,
          params: {
            systemIds: this.selectedSystemIds
          }
        });
      }

      // 画面上部へのアンカースクロール
      document.getElementById('scrollTabBlock').scrollIntoView({ behavior: 'instant' });
    },

    /**
     * ECU一覧のリストを更新する
     */
    updateEcuTable: function () {
      if (!this.multipleMenus || !this.multipleMenus.menu_list) {
        return;
      }
      // メニューサポートからシステムリストを取得
      const ecuArray = this.multipleMenus.menu_list.map((item) => item.system_name);
      const menuList = this.multipleMenus.menu_list;
      this.systemListItems = ecuArray.filter(ecu => {
        const targetMenu = menuList.find(menu => menu.system_name === ecu);
        return targetMenu && targetMenu.menu_display_config && targetMenu.menu_display_config[this.functionName];
      }).map(filterEcu => {
        return {
          name: this.$t(`diagSytem.${filterEcu}`),
          systemId: filterEcu
        };
      });
      // システム名でソートを行う
      this.systemListItems = util.sortItems(this.systemListItems, 'name', config.ASC);
    },
  },

  computed: {

    ...mapState({
      language: state => state.systems.language,
      multipleMenus: state => state.vehicle.multipleMenus,
    }),

    isDecisionEnabled() {
      // システムの選択数が下限以上の場合、決定ボタンを有効化
      return this.selectedSystemIds.length >= SELECT_SYSTEMS_LIMIT.MIN;
    }
  },

  created() {
  },

  mounted() {
    // タブ制御
    this.$emit("setVehicleTabsAvailable", true);
    this.updateEcuTable();
  },
};
